import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-04d962c8"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "no-user-content"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "toggle-tip"
}, [/*#__PURE__*/_createTextVNode(" 切换 "), /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-qiehuan"
})], -1));

const _hoisted_3 = {
  key: 0,
  class: "user-content"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top-text"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "user-name"
})], -1));

const _hoisted_5 = {
  key: 1,
  class: "user-content"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top-text"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "user-name"
})], -1));

const _hoisted_7 = {
  key: 2,
  class: "user-content"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top-text"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "user-name"
})], -1));

const _hoisted_9 = {
  key: 1,
  style: {
    "position": "relative",
    "height": "100%"
  }
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "toggle-tip"
}, [/*#__PURE__*/_createTextVNode(" 切换 "), /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-qiehuan"
})], -1));

const _hoisted_11 = {
  key: 1,
  class: "user-content"
};
const _hoisted_12 = {
  class: "top-text"
};
const _hoisted_13 = {
  class: "user-name"
};
const _hoisted_14 = {
  key: 2,
  class: "user-content"
};
const _hoisted_15 = {
  class: "top-text"
};
const _hoisted_16 = {
  class: "user-name"
};
const _hoisted_17 = {
  key: 3,
  class: "user-content"
};
const _hoisted_18 = {
  class: "top-text"
};
const _hoisted_19 = {
  class: "user-name"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

  const _component_el_dropdown = _resolveComponent("el-dropdown");

  const _component_StaticRoleCard = _resolveComponent("StaticRoleCard");

  const _component_CaretRight = _resolveComponent("CaretRight");

  const _component_el_icon = _resolveComponent("el-icon");

  const _component_RoleCard = _resolveComponent("RoleCard");

  return _openBlock(), _createElementBlock(_Fragment, null, [!$props.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dropdown, {
    trigger: "hover",
    "append-to-body": false,
    "show-arrow": false
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, {
      class: "role-dropdown"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.staticRoleList, (item, index) => {
        return _openBlock(), _createBlock(_component_el_dropdown_item, {
          key: item.name,
          onClick: $event => $options.toggleStaticList(item, index)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
          _: 2
        }, 1032, ["onClick"]);
      }), 128))]),
      _: 1
    })]),
    default: _withCtx(() => [_hoisted_2]),
    _: 1
  }), $data.staticRole == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_hoisted_4, _createVNode(_component_StaticRoleCard, {
    menuList: $data.staticList,
    zhsRole: $data.staticRole
  }, null, 8, ["menuList", "zhsRole"])])) : _createCommentVNode("", true), $data.staticRole == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_hoisted_6, _createVNode(_component_StaticRoleCard, {
    menuList: $data.staticList,
    zhsRole: $data.staticRole
  }, null, 8, ["menuList", "zhsRole"])])) : _createCommentVNode("", true), $data.staticRole == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_hoisted_8, _createVNode(_component_StaticRoleCard, {
    menuList: $data.staticList,
    zhsRole: $data.staticRole
  }, null, 8, ["menuList", "zhsRole"])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $props.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_9, [$props.zhsRole == 1 || $props.zhsRole == 2 ? (_openBlock(), _createBlock(_component_el_dropdown, {
    key: 0,
    trigger: "hover",
    "append-to-body": false,
    "show-arrow": false
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, {
      class: "role-dropdown"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.roleList, (item, index) => {
        return _openBlock(), _createBlock(_component_el_dropdown_item, {
          key: item.name,
          onClick: $event => $options.toggleZhsRole(item, index)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
          _: 2
        }, 1032, ["onClick"]);
      }), 128))]),
      _: 1
    })]),
    default: _withCtx(() => [_hoisted_10]),
    _: 1
  })) : _createCommentVNode("", true), $data.currentRole == 3 || $data.currentRole == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_icon, {
    style: {
      "color": "#758af6",
      "margin-right": "5px",
      "font-size": "24px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_CaretRight)]),
    _: 1
  }), _createElementVNode("span", _hoisted_13, _toDisplayString($props.userInfo.realname) + "同学，您好！", 1)]), _createVNode(_component_RoleCard, {
    menuList: $data.appList,
    zhsRole: $data.currentRole,
    onlineLink: $data.onlineLink.student
  }, null, 8, ["menuList", "zhsRole", "onlineLink"])])) : _createCommentVNode("", true), $data.currentRole == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_icon, {
    style: {
      "color": "#758af6",
      "margin-right": "5px",
      "font-size": "24px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_CaretRight)]),
    _: 1
  }), _createElementVNode("span", _hoisted_16, _toDisplayString($props.userInfo.realname) + "老师，您好！", 1)]), _createVNode(_component_RoleCard, {
    menuList: $data.appList,
    zhsRole: $data.currentRole,
    onlineLink: $data.onlineLink.teacher
  }, null, 8, ["menuList", "zhsRole", "onlineLink"])])) : _createCommentVNode("", true), $data.currentRole == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createVNode(_component_el_icon, {
    style: {
      "color": "#758af6",
      "margin-right": "5px",
      "font-size": "24px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_CaretRight)]),
    _: 1
  }), _createElementVNode("span", _hoisted_19, _toDisplayString($props.userInfo.realname) + "管理员，您好！", 1)]), _createVNode(_component_RoleCard, {
    menuList: $data.appList,
    zhsRole: $data.currentRole,
    onlineLink: $data.onlineLink.manage
  }, null, 8, ["menuList", "zhsRole", "onlineLink"])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 64);
}